// libs
import isEmpty from "lodash/isEmpty";

// helpers
import Storage from "shared/helpers/storage";

// api
import { getSearchAutoSuggest } from "shared/api/misc";

// constants
import { SEARCHES_KEY, SEARCHES_KEY_V2, MAX_RECENT_SEARCHES, TEXTS } from "./constants";

// defs
import { IAutoSuggestResponse, ISearchInfo, ITrackingProps } from "./types";

export const getRecentSearches = (): ISearchInfo[] => {
    let oldSearches = Storage.getItem<string[] | undefined>(SEARCHES_KEY);

    if (isEmpty(oldSearches) === false) {
        Storage.removeItem(SEARCHES_KEY);
    }

    const searches = Storage.getItem<ISearchInfo[] | undefined>(SEARCHES_KEY_V2);

    if (isEmpty(searches)) {
        return [];
    }

    // @ts-ignore
    return searches;
};

export const setNewSearch = (searchInfo: ISearchInfo) => {
    const searches = getRecentSearches();

    const newSearches = [searchInfo, ...searches]
        .filter((value: ISearchInfo, idx: number, self) => {
            return (
                self.some((loopValue, lIdx) => {
                    return idx > lIdx && loopValue.term === value.term;
                }) === false
            );
        })
        .slice(0, MAX_RECENT_SEARCHES);

    Storage.setItem(SEARCHES_KEY_V2, newSearches);
};

export const clearSearches = () => Storage.removeItem(SEARCHES_KEY_V2);

export const defaultSuggestionResponse: IAutoSuggestResponse = {
    status: "",
    message: "",
    response: {
        suggestions: [],
    },
};

export const getAutoSuggest = (term: string): Promise<IAutoSuggestResponse> => {
    return getSearchAutoSuggest(term)
        .then((response: any) => {
            return response;
        })
        .catch(() => {
            const defaultResponse = { ...defaultSuggestionResponse, message: TEXTS.OOPS };
            return defaultResponse;
        });
};

export const generateTrackingURLForSearch = ({
    url,
    searchType,
    internalSearchTerm,
    typedSearchTerm,
    suggestionType,
    clickIndex,
}: ITrackingProps) => {
    const param = new URLSearchParams();
    param.set("searchType", searchType);
    param.set("internalSearchTerm", internalSearchTerm);

    if (typedSearchTerm) {
        param.set("typedSearchTerm", typedSearchTerm);
    }

    if (suggestionType) {
        param.set("suggestionType", suggestionType);
    }

    if (clickIndex) {
        param.set("suggestionPosition", String(clickIndex));
    }

    if (url.indexOf("?") > 1) {
        return `${url}&${param.toString()}`;
    }

    return `${url}?${param.toString()}`;
};
